import { SM_QUEUE_SERVER } from "../constants/constants";
import { messageToSupervisor, triggerNotifications } from "../Helpers/helperMessages";
import { chatToAdminModel } from "../mappers/models.mapper";
import { Logger } from "../logging/Logger";
import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from "../constants/Notifications";

export const svrGetAdminsToChat = (svrResource, userID) => {
    const objResponse = svrResource.apiCont.getObjectResponse();
    svrResource.apiCont.getSupervisorList(userID, objResponse);
    objResponse.onError = function (messageError) {
        svrResource.errorEvents.errorListAdminsToChat([]);
        triggerNotifications(svrResource, messageError.InternalCode, messageError.Type, MESSAGE_FROM.CW, messageError.Message);
        Logger.Warn("[AgentSDK] [ResponseFromServer] [Error] failed to getSupervisorList: "+messageError.Message );
    };
    objResponse.onSuccess = function (objResponse) {
        const chatAdminModel = chatToAdminModel(objResponse.Response);
        svrResource.svrEvents.onListAdminsToChat(chatAdminModel);
        triggerNotifications(svrResource, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
    }
}

export const svrSendChatToAdmin = (svrResource, message, adminName, userID) => {
    const objResponse = svrResource.apiCont.getObjectResponse();
    svrResource.apiCont.getSupervisorList(userID, objResponse);
    objResponse.onError = function (messageError) {
        triggerNotifications(svrResource, messageError.InternalCode, messageError.Type, MESSAGE_FROM.CW, messageError.Message);
    };
    objResponse.onSuccess = function (objResponse) {
        const adminConnected = objResponse.Response.some(item => item.Username === adminName);
        if(adminConnected){
            let currentTime = new Date().toLocaleTimeString('en-US',{ hour12: false });
            let messageToList = { type: 2, text: message, user: userID, hour: currentTime };
            svrResource.sharedData.setObjectChat(messageToList, adminName);
            const msnToSM = messageToSupervisor(message, adminName);
            svrResource.sendToRabbit(SM_QUEUE_SERVER, msnToSM);
        }else{
            triggerNotifications(svrResource, MESSAGE_CODE.CHAT[11601], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
        }
        triggerNotifications(svrResource, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
    }
}


export const svrGetChatLog = (svrResource, message) => {
    if(svrResource.sharedData.isProblemStatus){
        chatStatusProblem(svrResource, message);
    } else {
        let objectResponse = svrResource.apiCont.getObjectResponse();
        svrResource.apiCont.getChatLog(svrResource.sharedData.user.User_id, objectResponse);
        objectResponse.onError = function (messageError) {
            console.log("[getChatLog] [Error]: ", messageError)
            svrResource.errorEvents.errorChatMessages([]);
            triggerNotifications(svrResource, MESSAGE_CODE.CHAT[11603], MESSAGE_TYPE.ERROR, MESSAGE_FROM.CW, messageError);
            Logger.Warn(" [AgentSDK] [ResponseFromServer] [Error] failed to getSupervisorList: "+messageError);
        };
        objectResponse.onSuccess = function (objResponse) {
            console.log("[getChatLog] [Success] [Ok]")
            svrResource.svrEvents.onChatMessages(objResponse);
            triggerNotifications(svrResource, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
        };
    }
}

export const chatStatusProblem = (svrResource, message) => {
    svrResource.sharedData.isProblemStatus = true;
    svrResource.svrEvents.onListAdminsToChat([{adminID: 1, adminName: "CW"}]);
    const msn = {
        CW: [{
            hour: svrResource.sharedData.getCurrentTime(),
            type: 1,
            text: message.Message,
            user: svrResource.sharedData.getUserData().Login
        }]
    }
    svrResource.svrEvents.onChatMessages(msn);
}